"use client";

import { useState, useEffect } from "react";
import { useTheme } from "next-themes";
import Image from "next/image";

export default function AuthLayout({ children }) {
  const { theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Prevent hydration mismatches on initial render
  useEffect(() => {
    setMounted(true);
  }, []);

  const logoSrc =
    theme === "dark"
      ? "/logo/aeronpay-hrms-logo-white.png"
      : "/logo/aeronpay-hrms-logo-dark.png";
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex flex-col justify-center items-center px-6 md:px-16 lg:px-24 py-12 bg-background">
        <div className="w-full max-w-sm mx-auto lg:mx-0">
          <div className="h-14 w-[180px] relative mb-16">
            {mounted && (
              <Image
                src={logoSrc}
                alt="AeronPay HRMS"
                fill
                priority
                className="object-contain object-left"
              />
            )}
          </div>

          {children}
        </div>
      </div>

      <div className="hidden lg:block relative m-4 rounded-2xl overflow-hidden">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 h-full w-full object-cover"
        >
          <source src="/auth/hrms-login-side.mov" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
        <div className="absolute bottom-8 left-8 right-8">
          <p className="text-white text-lg font-medium leading-snug">
            "AeronPay cut our HR admin time by 40% in the first quarter."
          </p>
          <p className="text-white/70 text-sm mt-2">
            Priya Sharma, Director of People Ops
          </p>
        </div>
      </div>
    </div>
  );
}